import { SystemEvent, SystemEventLevel } from '@shared-ui/logger-context';
export var LOG_EVENTS = {
  SIGNAL_EVENTS_CONTEXT_PUBLISH: new SystemEvent(SystemEventLevel.INFO, 'SIGNAL_EVENTS_CONTEXT_PUBLISH')
};